import * as actionTypes from "./actionTypes";

const initialState = {
  isLoading: false,
  newsDialogIsVisited: false,
  counters: [],
  downloads: [],
  links: [],
  modal: [],
  news: [],
  polls: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET:
      return { ...state, isLoading: true };
    case actionTypes.GET_FULFILLED:
      return {
        ...state,
        isLoading: false,
        counters: action.payload.counters,
        downloads: action.payload.downloads,
        links: action.payload.links,
        modal: action.payload.modal,
        news: action.payload.news,
        polls: action.payload.polls,
      };
    case actionTypes.GET_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.UPDATE_POLLS:
      return {
        ...state,
        polls: action.payload.polls,
      };

    case actionTypes.NEWS_DIALOG_IS_VISITED:
      return {
        ...state,
        newsDialogIsVisited: true,
        modal: [], // se vacia el contenido para que se abra solo cuando ya tenga la data nueva, sino, se abre antes de que termine de hacerse el GET
      };
    case actionTypes.NEWS_DIALOG_IS_NOT_VISITED:
      return {
        ...state,
        newsDialogIsVisited: false,
      };

    default:
      return state;
  }
}
